/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPoplistItem,
    JsonPoplistItemFromJSON,
    JsonPoplistItemFromJSONTyped,
    JsonPoplistItemToJSON,
} from './JsonPoplistItem';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonPoplistItem
 */
export interface ApiResultOfListOfJsonPoplistItem {
    /**
     * 
     * @type {Array<JsonPoplistItem>}
     * @memberof ApiResultOfListOfJsonPoplistItem
     */
    data?: Array<JsonPoplistItem>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoplistItem
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonPoplistItem
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoplistItem
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonPoplistItem
     */
    result?: ApiResultOfListOfJsonPoplistItemResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPoplistItemResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPoplistItemFromJSON(json: any): ApiResultOfListOfJsonPoplistItem {
    return ApiResultOfListOfJsonPoplistItemFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPoplistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonPoplistItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPoplistItemFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPoplistItemToJSON(value?: ApiResultOfListOfJsonPoplistItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPoplistItemToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

